import React from 'react';
import PropTypes from 'prop-types';
import {
  AlertDialog,
  AlertDialogBackdrop,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogCloseButton,
  AlertDialogFooter,
  AlertDialogBody,
  Heading, Text,
  Button, ButtonGroup, ButtonText, ButtonSpinner, CloseIcon,
  VStack, Icon,
} from '@gluestack-ui/themed';

export const PopupDialog = ({
  isOpen = false,
  title = 'Dialog',
  message = 'Are you sure?',
  buttons = [],
  onClose = () => {},
  children = null,
  size = 'md',
  showCloseButton = true,
}) => (
  <AlertDialog isOpen={isOpen} onClose={onClose} size={size}>
    <AlertDialogBackdrop />
    <AlertDialogContent bg="$bgCard">
      <AlertDialogHeader borderBottomWidth="$0">
        <VStack>
          {/* put icon here */}
          <Heading size="lg">{title}</Heading>
        </VStack>
        {showCloseButton && (
          <AlertDialogCloseButton>
            <Icon as={CloseIcon} mr="$4" mb="$2" />
          </AlertDialogCloseButton>
        )}
      </AlertDialogHeader>
      <AlertDialogBody>
        {!!message && <Text size="sm" color="$textSubtle">{message}</Text>}
        {children !== null ? children : null}
      </AlertDialogBody>
      <AlertDialogFooter>
        <ButtonGroup space="lg" justifyContent="flex-end" flexWrap="wrap">
          {buttons.map((button) => (
            <Button
              key={button.text}
              size="sm"
              testID={button?.testID || `button-${button.text}`}
              variant={button.variant}
              action={button.action}
              isDisabled={button?.isDisabled || button?.isLoading || false}
              onPress={() => {
                if (button?.isDisabled || button?.isLoading) {
                  return;
                }
                if (button.onPress) {
                  if (button.preventAutoClose) {
                    button.onPress(onClose);
                  } else {
                    button.onPress();
                    onClose();
                  }
                } else {
                  onClose();
                }
              }}
            >
              {button?.isLoading && <ButtonSpinner mr="$2" />}
              <ButtonText>{button.text}</ButtonText>
            </Button>
          ))}
        </ButtonGroup>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

PopupDialog.propTypes = {
  isOpen: PropTypes.bool,
  size: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      variant: PropTypes.string,
      action: PropTypes.string,
      onPress: PropTypes.func,
      isLoading: PropTypes.bool,
    }),
  ),
  onClose: PropTypes.func,
  children: PropTypes.node,
  showCloseButton: PropTypes.bool,
};

export default PopupDialog;
